'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

import { useFormat } from '@cineamo/ui/src/hooks/formatter/useFormat';

import { IconInfo16 } from '@cineamo/ui/src/icons/ic-info';
import { Seat } from '@cineamo/ui/src/seat-map/typedefs';

import { useCartProvider } from '../providers/cartProvider';

import { concessionLineTotal } from './concession-helper';
import SelectedSeatCartItem from './SelectedSeatCartItem';

type CartSummaryProps = {
    seats: Seat[];
    className?: string;
};

const CartSummary: React.FC<CartSummaryProps> = ({ seats, className }) => {
    const t = useTranslations('tickets');
    const { selectedSeats, currentStep, concessions, currency, onlineTicketingFee } = useCartProvider();
    const formatter = useFormat();
    return (
        <div
            className={cn(
                'mx-[9px] lg:mx-[16px] lg:m-[16px] lg:max-h-[100%] space-y-[8px] overflow-y-scroll',
                {
                    'hidden lg:flex': !['01_seat_picking', '01.5_cart', '02_payment'].includes(currentStep)
                },
                className
            )}>
            {selectedSeats.length > 0 && currentStep === '01_seat_picking' && (
                <div className="pb-16 text-body-bold-12 flex row space-x-12 leading-[20px] items-center text-[rgba(var(--on-background-color-rgb),0.5)]">
                    <IconInfo16 />
                    <p>{t('price-category-info')}</p>
                </div>
            )}
            {selectedSeats.flatMap((selectedSeat) => {
                const seat = seats.find((s) => s.id === selectedSeat.id);
                if (!seat) {
                    return [];
                }
                return (
                    <SelectedSeatCartItem
                        key={seat.id}
                        seat={seat}
                        selectedSeat={selectedSeat}
                        isDisabled={currentStep !== '01.5_cart'}
                    />
                );
            })}
            {concessions.map((concession) => (
                <div
                    key={concession.id}
                    className="flex space-x-16 p-[8px]">
                    <span className="grow text-body-bold-16">
                        {concession.quantity}x {concession.name}
                    </span>
                    <span className="shrink-0 text-body-bold-16">
                        {formatter.number.formatCurrency(
                            concessionLineTotal(concession, onlineTicketingFee) / 100,
                            currency
                        )}
                    </span>
                </div>
            ))}
            {/* {cart.items
                        .filter((item) => item._embedded.product.type === 'SeatLock')
                        .map((cartItem) => (
                            <SelectedSeatCartItem
                                key={cartItem._embedded.product.id}
                                cartItem={cartItem}
                                discounts={priceDiscounts}
                                currency={cart.currency}
                                onDiscountSelect={(selectedDiscount) =>
                                    applyDiscount(cartItem._embedded.product.id, selectedDiscount)
                                }
                            />
                        ))} */}

            {/* {items
                        .filter((item) => item._embedded.product.type === '')
                        .map((cartItem) => (
                            <SelectedCartItem
                                key={cartItem.id}
                                cartItem={cartItem}
                                currency={currency}
                            />
                        ))} */}
        </div>
    );
};

export default CartSummary;
